import { Table, Row, Col, Button, message, Modal, Space, Tag, Pagination } from "antd";
import { DeleteOutlined, ExclamationCircleOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from '../../../utils/axios';
import dayjs from "dayjs";

export default function PricingDashboard() {
  const [packages, setPackages] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, pageSize: 10 });

  const fetchPackages = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/pricing/getAll`, { params: pagination });
      setPackages(res?.data || {});
    } catch {
      message.error("Lỗi tải dữ liệu!");
    }
  };

  const removePackage = async (id) => {
    await axios.delete(`${process.env.REACT_APP_API_URL}/pricing/delete/${id}`);
    message.success("Xóa thành công!");
    fetchPackages();
  };

  const confirmDelete = (id) => {
    Modal.confirm({
      icon: <ExclamationCircleOutlined />,
      content: "Bạn có chắc chắn xoá gói giá này?",
      okText: "Xác nhận",
      cancelText: "Huỷ",
      onOk: () => removePackage(id),
    });
  };

  useEffect(() => {
    fetchPackages();
  }, [pagination]);

  const formatPrice = (price) => new Intl.NumberFormat('vi-VN').format(price) + 'đ';

  const columns = [
    { title: "ID", dataIndex: "id", key: "id", width: 60, sorter: (a, b) => a.id - b.id },
    { title: "Tên gói", dataIndex: "name", key: "name", width: 150 },
    {
      title: "Giá", dataIndex: "price", key: "price", width: 120,
      sorter: (a, b) => a.price - b.price,
      render: (_, record) => <span className="font-semibold text-blue-600">{formatPrice(record.price)}</span>
    },
    { title: "Thời hạn (ngày)", dataIndex: "duration_days", key: "duration_days", width: 120 },
    { title: "Mô tả", dataIndex: "description", key: "description", width: 200, render: (text) => <div className="max-w-[200px] truncate">{text}</div> },
    {
      title: "Trạng thái", dataIndex: "is_active", key: "is_active", width: 100,
      render: (_, record) => record.is_active ? <Tag color="green">Active</Tag> : <Tag color="red">Inactive</Tag>
    },
    {
      title: "Phổ biến", dataIndex: "is_popular", key: "is_popular", width: 100,
      render: (_, record) => record.is_popular ? <Tag color="gold">★ Popular</Tag> : <Tag>Normal</Tag>
    },
    {
      title: "Thao tác", key: "action", width: 120,
      render: (_, record) => (
        <Space>
          <Link to={`/admin/pricing/${record.id}`}><EditOutlined className="text-blue-500" /></Link>
          <DeleteOutlined className="text-red-500 cursor-pointer" onClick={() => confirmDelete(record.id)} />
        </Space>
      )
    },
  ];

  return (
    <>
      <Row gutter={10} className="mb-2">
        <Col flex={1}>
          <div className="text-[20px] font-medium pb-5 pt-5">Quản lý bảng giá</div>
        </Col>
        <Col>
          <Link to="/admin/pricing/create">
            <Button type="primary" icon={<PlusOutlined />} className="mt-5">Tạo gói mới</Button>
          </Link>
        </Col>
      </Row>
      <div className="w-full h-full mt-5 pb-20 relative">
        <Table
          className="custom-table"
          dataSource={packages?.data}
          columns={columns}
          pagination={false}
          rowKey="id"
        />
        <Pagination
          className="flex justify-center absolute inset-x-0 bottom-10"
          current={pagination.page}
          total={packages?.total}
          pageSize={pagination.pageSize}
          showSizeChanger
          onChange={(p, ps) => setPagination({ page: p, pageSize: ps })}
        />
      </div>
    </>
  );
}
